import { defineTokens } from '@chakra-ui/react/styled-system';

const fonts = defineTokens.fonts({
  body: {
    value: '"Figtree Variable", sans-serif',
  },
  mono: {
    value: '"Source Code Pro Variable", monospace',
  },
});

export default fonts;
